import React from 'react';
import getLogger from '@ignitesales/logger-es';
import classNames from 'classnames';
import { QuestionTypeViewPropTypes } from '../../utils';
import { useNeuroMessages } from '../MessageContext';

const logger = getLogger({ component: 'Dropdown' });

const Dropdown = (props) => {
  const {
    className,
    valueChanged,
    question,
    value: { value = {} } = {},
  } = props;

  const messageContext = useNeuroMessages();

  const answers = question.answers;
  const currentValue = value && value.length > 0 ? value[0] : value;
  let selectedIndex = answers.findIndex((a) => a.key === currentValue);

  const classes = classNames(className, {
    dropdown: true,
    'dropdown--unanswered': selectedIndex === -1,
  });

  const getSelectOptions = () => {
    return answers.map((option, index) => {
      return (
        <option key={index} value={index}>
          {messageContext.formatIntlMessage({
            id: `${question.appkey}.${option.key}`,
          })}
        </option>
      );
    });
  };

  const onChange = (event) => {
    let targetIndex = 0;
    try {
      targetIndex = parseInt(event.target.value);
    } catch (ex) {
      logger.error('Something really unfortunate happened in a Dropdown');
    }
    /** eslint-disable next-line security/detect-object-injection **/
    if (
      targetIndex >= 0 &&
      targetIndex < answers.length &&
      answers[targetIndex] &&
      answers[targetIndex].key
    ) {
      /** eslint-disable next-line security/detect-object-injection **/
      valueChanged(answers[targetIndex].key);
    } else {
      valueChanged([]);
    }
  };

  const message =
    messageContext.getMessage(`${question.appkey}.input.placeholder`) ||
    messageContext.getMessage('pleaseSelect');

  return (
    <div className={classes}>
      <div className="dropdown__container">
        <select onChange={onChange} value={selectedIndex}>
          <option key={-1} value={-1}>
            {message}
          </option>
          {getSelectOptions()}
        </select>
      </div>
    </div>
  );
};

Dropdown.propTypes = QuestionTypeViewPropTypes;

export default Dropdown;
